/**
 * Best-effort extraction of a fiat minimum from an Alfred / proxy error
 * string. Used when a live quote rejects an amount that our cached
 * `/supported-options` min still thinks is valid (stale configs cache).
 */
export const parseAlfredMinFromError = (raw: string): number | null => {
  if (!raw) return null;
  const text = raw.replace(/^Error:\s*/i, "").trim();
  const patterns = [
    /min(?:imum)?(?:\s*amount)?[^\d]{0,32}(\d+(?:\.\d+)?)/i,
    /below[^\d]{0,32}(\d+(?:\.\d+)?)/i,
    /at\s*least[^\d]{0,32}(\d+(?:\.\d+)?)/i,
    /mín(?:imo)?[^\d]{0,32}(\d+(?:\.\d+)?)/i,
    /AMOUNT_BELOW_MINIMUM[^\d]{0,32}(\d+(?:\.\d+)?)/i,
  ];
  for (const re of patterns) {
    const match = text.match(re);
    if (!match) continue;
    const value = Number(match[1]);
    if (Number.isFinite(value) && value > 0) return value;
  }
  return null;
};

/** True when the quote failure is an amount/limit rejection (not a network blip). */
export const isAlfredAmountQuoteError = (raw: string): boolean => {
  const text = (raw || "").toLowerCase();
  return (
    text.includes("amount") ||
    text.includes("minimum") ||
    text.includes("minimo") ||
    text.includes("mínimo") ||
    text.includes("quantity") ||
    text.includes("below") ||
    text.includes("409") ||
    text.includes("amount_below_minimum")
  );
};
